import { render } from "./TyreAlignedCard.vue?vue&type=template&id=0f3fc148"
import script from "./TyreAlignedCard.vue?vue&type=script&lang=js"
export * from "./TyreAlignedCard.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__